/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { SpinnerIcon } from '@coursera/cds-icons';

type Props = {
  size?: 'small' | 'medium' | 'large';
  color?: 'default' | 'error' | 'invert' | 'success' | 'support' | 'interactive' | 'warning';
  className?: string;
};

const styles = {
  animated: css`
    animation: var(--labs-animation-spin);
  `,
};

function LoadingIcon({ size, color, className }: Props): React.ReactElement {
  return <SpinnerIcon size={size} color={color} className={className} css={styles.animated} />;
}

export default LoadingIcon;
